import Stack from 'components/commons/stack';
import Text from 'components/commons/text';
import { styled } from 'styles';
import typography from 'styles/typography';

export const ticketStyles = {
  closeContainer: {
    backgroundColor: '$white',
    borderRadius: 99,
    padding: 4,
    alignItems: 'center',
  },
  dialogBackdrop: {
    padding: 4,
    '& > .react-reveal': {
      width: '100%',
      display: 'flex',
      justifyContent: 'center',
      height: '100%',
      overflow: 'auto',
      '@lg': {
        alignItems: 'center',
      },
      '& > div': {
        width: '100%',
        '@md': {
          maxWidth: 1000,
        },
      },
    },
  },
};

export const styles = {
  bigText: {
    ...typography.headline7,
    '@md': typography.headline5,
    fontWeight: '700 !important',
  },

  rightChevron: {
    ml: 8,
    backgroundColor: '$white',
    borderRadius: 99,
    pt: 4,
    pb: 4,
    pr: 3,
    pl: 5,
    alignItems: 'center',
    width: 24,
    height: 24,
    display: 'none',
    '@sm': {
      width: 'fit-content',
      height: 'fit-content',
      display: 'flex',
    },
  },

  leftChevron: {
    mr: 8,
    backgroundColor: '$white',
    borderRadius: 99,
    pt: 4,
    pb: 4,
    pl: 3,
    pr: 5,
    alignItems: 'center',
    width: 24,
    height: 24,
    display: 'none',
    '@sm': {
      width: 'fit-content',
      height: 'fit-content',
      display: 'flex',
    },
  },
};

export const TicketContainer = styled('div', {
  display: 'flex',
  alignItems: 'center',
});

export const TicketContent = styled('div', {
  backgroundColor: '$white',
  display: 'flex',
  flex: 1,
  position: 'relative',
  overflow: 'hidden',
  flexDirection: 'column',
  '@lg': {
    flexDirection: 'row',
  },
});

export const LeftContent = styled('div', {
  position: 'relative',
  flex: 3,
  display: 'flex',
  flexDirection: 'column',
  padding: 16,
  '@lg': {
    padding: 24,
  },
});
export const RightContent = styled('div', {
  padding: 16,
  position: 'relative',
  flex: 2,
  display: 'flex',
  flexDirection: 'column',
  '@lg': {
    padding: 24,
    borderTop: 'none',
    borderLeft: '2px dashed $neutral2',
  },
});

export const Circle = styled('div', {
  position: 'absolute',
  height: 40,
  width: 40,
  backgroundColor: '#bfbfbf',
  borderRadius: 999,
  zIndex: 5,
});

export const Container = styled('div', {
  display: 'flex',
  flexDirection: 'column',
  py: 8,
});

export const SmallLabel = styled(Text, {
  color: '$typeGray',
  ...typography.body6,
  '@md': typography.body4,
});

export const SmallText = styled(Text, {
  mb: 4,
  ...typography.body6,
  '@md': typography.body5,
});

export const PortText = styled(Text, {
  ...typography.headline7,
  '@md': typography.headline4,
  fontWeight: 'bold !important',
});

export const LocationText = styled(Text, {
  color: '$typeGray',
  ...typography.body6,
  '@md': typography.body3,
  fontWeight: '600 !important',
  mt: 8,
});

export const BlueText = styled(Text, {
  ...typography.headline7,
  '@md': {
    ...typography.headline6,
    fontWeight: '700',
  },
  color: '$primary',
});

export const TimeText = styled(Text, {
  ...typography.body5,
  fontWeight: 600,
  textAlign: 'center',
  flex: '1 !important',
  display: 'flex',
  '@md': typography.headline7,
  '@lg': {
    textAlign: 'left',
  },
});

export const TicketText = styled(Text, {
  ...typography.body5,
  '@md': typography.body3,
});

export const PriceText = styled(Text, {
  ...typography.body5,
  '@md': typography.body1,
});

export const ReminderText = styled(Text, {
  ...typography.body6,
  '@lg': typography.body3,
});

export const PassengerInformationText = styled(Text, {
  ...typography.headline7,
  mt: 8,
  '@lg': typography.headline5,
});
export const ContainerIndicator = styled('div', {
  position: 'relative',
  bottom: 32,
  left: 0,
  right: 0,
  margin: 'auto',
  display: 'flex',
  gap: 4,
  zIndex: 10,
  justifyContent: 'center',
});
export const Indicator = styled('div', {
  borderRadius: 9999,
  width: 8,
  height: 8,
  cursor: 'pointer',
  variants: {
    variant: {
      active: {
        backgroundColor: '$primary',
      },
      inactive: {
        background: '$typeGray',
      },
    },
  },
  '@sm': {
    display: 'none',
  },
});

export const TicketLogoImage = styled('img', {
  aspectRatio: '2.27:1',
  width: 120,
  objectFit: 'cover',
  '@sm': {
    width: 130,
  },
  '@lg': {
    width: 180,
  },
});
export const TicketLogoContainer = styled(Stack.Item, {
  display: 'flex',
});
